import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { DownOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import ReactLoading from "react-loading";
import { useReactToPrint } from "react-to-print";
import "./Buttons.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
function BtnPrint({ size, divId, fileName }) {
  const [isClicked, setIsClicked] = useState(false);
  const items = [
    {
      label: 'A5',
      key: 'a5',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'A4',
      key: 'a4',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Letter',
      key: 'letter',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Legal',
      key: 'legal',
      icon: <PaperClipOutlined />,
    },
  ];

const handlePrint = async (e) => {
    setIsClicked(true);
    const input = divId.current;
    const padding = 5; // Small padding for margins
  
    html2canvas(input, { backgroundColor: null }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF('p', 'mm', e?.key, true);
  
      const pageWidth = pdf.internal.pageSize.getWidth() - 2 * padding;
      const pageHeight = pdf.internal.pageSize.getHeight() - 2 * padding;
      
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);
      const scaledImgWidth = imgWidth * ratio;
      const scaledImgHeight = imgHeight * ratio;
  
      let y = 5; // Initial Y position
  
      // Split content into multiple pages if it overflows
      if (scaledImgHeight > pageHeight) {
        let totalPages = Math.ceil(scaledImgHeight / pageHeight);
        for (let i = 0; i < totalPages; i++) {
          if (i > 0) pdf.addPage();
          const chunkHeight = Math.min(pageHeight, scaledImgHeight - (i * pageHeight));
          pdf.addImage(imgData, "PNG", padding, y, scaledImgWidth, chunkHeight);
        }
      } else {
        pdf.addImage(imgData, "PNG", padding, y, scaledImgWidth, scaledImgHeight);
      }
  
      // Save and print the PDF
      // pdf.save(fileName);
      pdf.autoPrint();
      pdf.output("dataurlnewwindow");
    });
  
    setIsClicked(false);
  };
  
  

  const menuProps = {
    items,
    onClick: (e) => handlePrint(e),
  };

  return (
    <Col>
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#2d6e5e" />
        </Button>
      ) : (
        <Dropdown menu={menuProps}>
          <Button className="action-btn clear" size={size}>
              Print
              <DownOutlined />
          </Button>
        </Dropdown>
      )}
    </Col>
  );
}

export default BtnPrint;

